const shoppingCartKey = "hans_user_shopping_cart"
const shoppongMallInfoKey = "hans_user_shopping_mall_info"
  export function  saveShoppingCart(data) {
    localStorage.setItem(shoppingCartKey, JSON.stringify(data))
  }
  export function  getShoppingCart() {
    var val = localStorage.getItem(shoppingCartKey);
    let resut = JSON.parse(val);
    return resut
  }
  export function clearShoppingCart(){
    localStorage.removeItem(shoppingCartKey)
  }
  export function  clearAll(){
    localStorage.removeItem(shoppingCartKey)
    localStorage.removeItem(tokenKey)
  }

  export function saveMallInfo(data){
    localStorage.setItem(shoppongMallInfoKey, JSON.stringify(data))
  }
  export function getMallInfo(){
    var val = localStorage.getItem(shoppongMallInfoKey);
    let result = JSON.parse(val);
    return result
  }


// WEBPACK FOOTER //
// ./src/store/shoppingcart.js